import * as React from 'react';

var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgDeliveryChosenDuotone24 = function SvgDeliveryChosenDuotone24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.52 10.06h4.98c1.181 0 2.17.819 2.432 1.92h2.066c.49 0 .97.145 1.38.415l1.502.995A2.5 2.5 0 0 1 24 15.475V19.5a2.5 2.5 0 0 1-2.5 2.5h-1.259a2.901 2.901 0 0 1-5.515 0H10.78a2.901 2.901 0 0 1-5.516 0H4.88a2.5 2.5 0 0 1-2.5-2.5v-7.98h1v7.98a1.5 1.5 0 0 0 1.5 1.5h.245a2.9 2.9 0 0 1 5.796 0h3.664A2.9 2.9 0 0 1 17 18.24v-5.68a1.5 1.5 0 0 0-1.5-1.5h-4.98v-1ZM21.5 21h-1.118A2.901 2.901 0 0 0 18 18.246V12.98h1.998a1.5 1.5 0 0 1 .828.25l1.502.994a1.5 1.5 0 0 1 .672 1.25v.026h-3v1h3v3a1.5 1.5 0 0 1-1.5 1.5Zm-11.577.1a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0Zm9.46 0a1.9 1.9 0 1 1-3.8 0 1.9 1.9 0 0 1 3.8 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "secondary-color",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 7c0-3.86 3.14-7 7-7 3.859 0 7 3.14 7 7 0 3.859-3.141 7-7 7-3.86 0-7-3.141-7-7Zm11.354-2.646a.5.5 0 0 0-.707-.708L5.954 8.338l-2.653-2.01a.5.5 0 1 0-.604.798l3.347 2.536 5.309-5.308Z",
    fill: "currentColor"
  })));
};

var DeliveryChosenDuotone24Svg = SvgDeliveryChosenDuotone24;

export { DeliveryChosenDuotone24Svg as default };
//# sourceMappingURL=DeliveryChosenDuotone24.svg.js.map
